import { render } from "./ResourceUnavailableModal.vue?vue&type=template&id=06e20330"
import script from "./ResourceUnavailableModal.vue?vue&type=script&lang=js"
export * from "./ResourceUnavailableModal.vue?vue&type=script&lang=js"

import "./ResourceUnavailableModal.vue?vue&type=style&index=0&id=06e20330&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__